import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new-student-container pa-6 rounded-lg" }
const _hoisted_2 = { class: "d-flex justify-end" }

import {ref} from "vue";
import {classes} from "@/api";
import {useApi} from "@/api/handler";

export default /*@__PURE__*/_defineComponent({
  __name: 'NewStudent',
  props: {
    cid: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const studentID = ref<string>('')
const studentName = ref<string>('')

const emits = __emit
const rules = {
  snoRequired: (value: string) => !!value || '学号不可为空',
  nameRequired: (value: string) => !!value || '姓名不可为空'
}

function handleSubmit() {
  if (studentID.value === "" || studentName.value === "") {
    return
  }
  useNewClass()
}

const useNewClass = () => {
  useApi({
    api: classes.UploadStudentSingle(props.cid, studentID.value, studentName.value),
    onSuccess: () => {emits('close')},
    tip: '添加成功'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-h6 mb-4" }, "手动添加学生", -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_v_text_field, {
        modelValue: studentID.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((studentID).value = $event)),
        variant: "outlined",
        density: "compact",
        placeholder: "请输入学号",
        rules: [rules.snoRequired],
        "prepend-inner-icon": "mdi-identifier",
        class: "my-2"
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_component_v_text_field, {
        modelValue: studentName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((studentName).value = $event)),
        variant: "outlined",
        density: "compact",
        placeholder: "请输入姓名",
        rules: [rules.nameRequired],
        "prepend-inner-icon": "mdi-account"
      }, null, 8, ["modelValue", "rules"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        color: "info",
        class: "mr-4",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("确认")
        ])),
        _: 1,
        __: [3]
      }),
      _createVNode(_component_v_btn, {
        color: "red-lighten-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('close')))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("取消")
        ])),
        _: 1,
        __: [4]
      })
    ])
  ]))
}
}

})